export function setMultiCurrencyEnabled(multiCurrencyEnabled) {
    return async function (dispatch) {
        dispatch({
            type: "SET_MULTI_CURRENCY_ENABLED",
            multiCurrencyEnabled
        })
    }
}

export function setSelectedCurrency(selectedCurrency) {
    return async function (dispatch) {
        dispatch({
            type: "SET_SELECTED_CURRENCY",
            selectedCurrency
        })
    }
}